import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './Recruit.css';

export default function Recruit() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        setSubNav([
            { 
                href: '#mark1', 
                label: '인재상', 
                active: true,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark1')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            },
            { 
                href: '#mark2', 
                label: '복리후생', 
                active: false,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark2')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        ]);

        return () => setSubNav(null);
    }, [setSubNav]);

    return (
        <>
            <div className="container">
                <div className="cont_visual recruit">
                    <h2>함께 미래를 만들어갈 인재</h2>
                    <p>
                        열정을 가진 인재, 함께 발전을 꿈꿀 수 있는 당신의 도전을 기다립니다.<br />
                        창의적이고 우수한 인재 육성에 지원을 아끼지 않으며 개인의 성장을 응원합니다.
                    </p>
                </div>
                <div className="cont wrap_cont">
                    <div className="cont_p" id="mark1">
                        <div className="cont_left">
                            <h3>인재상</h3>
                        </div>
                        <div className="cont_right">
                            <div className="people">
                                <div className="people_1">
                                    <h4>전문성을 갖춘 인재</h4>
                                    <p>
                                        열정을 가지고 <br />
                                        자신의 분야에서 끊임없이 성장하고 <br />
                                        함께 성과를 창출하는 인재
                                    </p>
                                </div>
                                <div className="people_2">
                                    <h4>창의적인 인재</h4>
                                    <p>
                                        열린 사고와 도전 정신으로 <br />
                                        변화와 혁신을 추구하는 <br />
                                        창의적인 인재
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cont_p" id="mark2">
                        <h3>복리후생</h3>
                        <div className="cont benefits_infography">
                            <div className="benefit_cont benefit1">
                                <div className="benefit_img benefit_img1"></div>
                                <div className="benefit_txt benefit_txt1">
                                    <h4><b>매월 우수사원 선정</b></h4>
                                    <p>매월 우수사원을 선정하여<br />시상합니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit2">
                                <div className="benefit_img benefit_img2"></div>
                                <div className="benefit_txt benefit_txt2">
                                    <h4><b>자기계발비 지원</b></h4>
                                    <p>임직원들의 자기계발을 위해<br />1년에 4회 분기별 지원됩니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit3">
                                <div className="benefit_img benefit_img3"></div>
                                <div className="benefit_txt benefit_txt3">
                                    <h4><b>퇴직 연금 제도</b></h4>
                                    <p>금융기관의 퇴직연금관리 제도를<br />도입하여 운용됩니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit4">
                                <div className="benefit_img benefit_img4"></div>
                                <div className="benefit_txt benefit_txt4">
                                    <h4><b>경조사 지원</b></h4>
                                    <p>경조휴가 및 경조금 지급이<br />이루어집니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit5">
                                <div className="benefit_img benefit_img5"></div>
                                <div className="benefit_txt benefit_txt5">
                                    <h4><b>건강검진 시행</b></h4>
                                    <p>임직원의 건강유지를 위하여<br />매년 1회 건강검진을 시행합니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit6">
                                <div className="benefit_img benefit_img6"></div>
                                <div className="benefit_txt benefit_txt6">
                                    <h4><b>비거주자 숙소 지원</b></h4>
                                    <p>근무지역의 비거주자 직원에 대하여<br />숙소 제공됩니다.</p>
                                </div>
                            </div>
                            <div className="benefit_cont benefit7">
                                <div className="benefit_img benefit_img7"></div>
                                <div className="benefit_txt benefit_txt7">
                                    <h4><b>명절 및 생일선물 지급</b></h4>
                                    <p>명절 2회, 생일, 창립기념일에<br />감사의 선물을 증정합니다.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
